import { useEffect, useState } from "react";

import { Box } from "@mui/material";

import useSurvey from "../../hooks/useSurvey";
const PageStatus = ({ page, sections, questions, answers, location, call }) => {
  const { getPageStatus } = useSurvey();

  const [pageStatus, setPageStatus] = useState({
    colorCode: "#ccc",
  });

  useEffect(() => {
    const getStatus = async () => {
      const status = await getPageStatus(
        page,
        sections,
        questions,
        answers,
        location,
        call,
      );

      setPageStatus(status);
    };

    getStatus();
  }, [page, sections, questions, answers, location, call]);

  return (
    <Box
      sx={{
        width: "5px",
        height: "5px",
        backgroundColor: pageStatus.colorCode,
        margin: "1px",
        borderRadius: "50%",
      }}
    ></Box>
  );
};

export default PageStatus;
